import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import { DateRange } from './date-range-picker.component';

@Component({
  selector: 'app-date-range-picker-popover',
  template: `
    <ion-content class="ion-padding">
      <app-date-range-picker
        [initialDateRange]="initialDateRange"
        (dateRangeChanged)="onDateRangeChanged($event)"
        (cancelled)="dismiss()"
      ></app-date-range-picker>
    </ion-content>
  `,
  styles: [
    `
      ion-content {
        --padding-start: 0;
        --padding-end: 0;
        --padding-top: 0;
        --padding-bottom: 0;
        --background: var(--ion-item-background);
      }
    `,
  ],
})
export class DateRangePickerModalComponent {
  @Input() initialDateRange?: DateRange;

  @Output() dateRangeSelected = new EventEmitter<DateRange>();

  constructor(private popoverCtrl: PopoverController) {}

  onDateRangeChanged(dateRange: DateRange) {
    // This is called when Update button is clicked
    this.popoverCtrl.dismiss(dateRange);
  }

  dismiss() {
    this.popoverCtrl.dismiss();
  }
}
